// extracted by mini-css-extract-plugin
export default {"button":"menu-destructive-item__button___kMnV- menu-item__button___QrH5n base__button___zT0JW"};